import {
    getAroReports,
    REPORTING_REPORT_KEY,
} from "../routers/AroReportScreen";
import {
    getEventsPerformanceReports,
    EVENTS_PERFORMANCE_REPORT_KEY,
} from "../pages/EventsPerformanceScreen";
import {
    getQBRInsightsReports,
    QBR_INSIGHTS_REPORT_KEY,
} from "../pages/QBRInsightsScreen";

export const PDF_BUILDER_TEMPLATES = {
    [REPORTING_REPORT_KEY]: getAroReports,
    [EVENTS_PERFORMANCE_REPORT_KEY]: getEventsPerformanceReports,
    [QBR_INSIGHTS_REPORT_KEY]: getQBRInsightsReports,
};
